import { render } from "./PagedCollectionInFolder.vue?vue&type=template&id=7e23c296&scoped=true"
import script from "./PagedCollectionInFolder.vue?vue&type=script&lang=js"
export * from "./PagedCollectionInFolder.vue?vue&type=script&lang=js"

import "./PagedCollectionInFolder.vue?vue&type=style&index=0&id=7e23c296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e23c296"]])

export default __exports__